import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import TextArea from '@/common/components/TextArea'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useDisableClientPriceSurvey } from '@/features/privateCompanies/hooks/priceSurvey/useDisablePriceSurvey'
import {
  disablePriceSurveySchema,
  DisablePriceSurveyValidationSchema,
} from '@/features/privateCompanies/schemas/disablePriceSurvey.schema'
import { zodResolver } from '@hookform/resolvers/zod'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

interface DisablePriceSurveyModalProps {
  priceSurveyId?: string
}

export const DisablePriceSurveyModal = ({ priceSurveyId }: DisablePriceSurveyModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: disableClientPriceSurvey } = useDisableClientPriceSurvey({
    priceSurveyId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companyPriceSurvey', priceSurveyId] })
      reset()
      setIsOpen(false)
    },
    onError: (error) => FormTransformers.errorsTransformer({ setError, setMessages })(error),
  })

  const {
    register,
    reset,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<DisablePriceSurveyValidationSchema>({
    resolver: zodResolver(disablePriceSurveySchema),
  })

  const onSubmit: SubmitHandler<DisablePriceSurveyValidationSchema> = (data) => {
    disableClientPriceSurvey(data)
  }

  return (
    <>
      <Modal
        Trigger={
          <Button
            operationKlassToCheckPermission="Admin::Client::PriceSurveys::Disable"
            type="button"
            variant="outline-error"
          >
            Desativar
          </Button>
        }
        title="Desativar pesquisa de preços"
        subtitle="Preencha o motivo para desativar esta pesquisa."
        subtitleClassName="mt-1 text-white-300"
        showClose={false}
        useCancellableFooter
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onConfirm={handleSubmit(onSubmit)}
        body={
          <form className="text-white-800">
            <TextArea
              label="Justificativa"
              placeholder="Escreva aqui sua justificativa"
              markAsRequired
              {...register('disable_reason')}
              errorMessage={errors.disable_reason?.message}
              variant={errors.disable_reason?.message ? 'error' : 'default'}
            />
          </form>
        }
      />

      {messages && <ModalMessageSimple messages={messages} setMessages={setMessages} isError />}
    </>
  )
}
